import React, { useState } from "react";
import axios from "axios";
import { Button, Modal, Form, Input, message, InputNumber, Checkbox } from "antd";
import { useMutation, useQueryClient } from "react-query";

export default function PutNegozioModal({ negozio }) {

  const [isModalVisible, setIsModalVisible] = useState(false);

  // Get QueryClient from the context
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (negozio) => {
      return axios.put(
        `${process.env.REACT_APP_SERVER_URL}/api/negozi`,
        negozio
      );
    },
    {
      onError: (error, variables, context) => {
        message.error(error.message);
      },
      onSuccess: (data, variables, context) => {
        console.log(data);
        setIsModalVisible(false);
        message.success("utenti aggiornato con successo");
        queryClient.invalidateQueries("negozi");
      },
    }
  );

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    // console.log('Success:', values);
    mutation.mutate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  console.log(negozio);

  return (
    <div>
      <Button type="primary" onClick={showModal}>
        Cambia dati del negozio
      </Button>
      <Modal
        title="Aggiornamento negozio"
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleOk}
        footer={[]}
      >
        <Form
          name="Aggiornamento dati negozio"
          onFinish={onFinish}
          initialValues={negozio}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="id" name="id">
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Inserire un nome utente" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="diretto"
            label="Diretto"
            valuePropName="checked">
            <Checkbox />
          </Form.Item>

          <h3>Coordinate geografiche</h3>

          <Form.Item
            label="Indirizzo"
            name="indirizzo"
            rules={[{ required: true, message: "Inserire l'indirizzo di questo negozio per favore !" }]}
          >
            <Input />
          </Form.Item>

          <p className="grey">Esempio, Roma, Latitudine: 41.9028, Longitudine: 12.4964</p>

          <Form.Item
            label="Latitudine"
            name="latitudine"
          >
            <InputNumber
              style={{ width: '150px' }}
              min={34}
              max={49}
              placeholder="45.6393414"
              step="0.01"
              stringMode
            />
          </Form.Item>

          <Form.Item
            label="Longitudine"
            name="longitudine"
          >
            <InputNumber
              style={{ width: '150px' }}
              min={5}
              max={20}
              placeholder="9.123241"
              step="0.01"
              stringMode
            />
          </Form.Item>



          <h3>Cambiare password</h3>

          <Form.Item
            label="Nuova Password"
            name="password"
            rules={[{ required: false, message: "Inserire una nuova password per favore" }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="Conferma password"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: false,
                message: "Confermare la password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Le password non sono identiche!");
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Aggiorno
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
